import { defineMessages } from "react-intl";

const messages = defineMessages({
  connectedEmailDisconnect: {
    id: "settings.emailPreferences.connectedEmail.disconnect",
    defaultMessage: "Disconnect",
    description: "Settings Email Preferences connected email disconnect button",
  },
  connectedEmailDisconnectChangeEmail: {
    id: "settings.emailPreferences.connectedEmail.changeEmail",
    defaultMessage: "Change email",
    description: "Settings Email Preferences connected email change email button",
  },
  connectedEmailTitle: {
    id: "settings.emailPreferences.connectedEmail.title",
    defaultMessage: "Connected email",
    description: "Settings Email Preferences connected email title",
  },
  disabledWhileSyncInProgress: {
    id: "settings.emailPreferences.tooltip.disabledWhileSyncInProgress",
    defaultMessage: "Disabled while sync is in progress",
    description: "Settings Email Preferences disabled while sync in progress tooltip",
  },
  disconnectedEmailConnect: {
    id: "settings.emailPreferences.disconnectedEmail.connect",
    defaultMessage: "Let’s go!",
    description: "Settings Email Preferences disconnected email connect button",
  },
  disconnectedEmailSubTitle: {
    id: "settings.emailPreferences.disconnectedEmail.subTitle",
    defaultMessage:
      "Syncing your email enables you to send tracked emails to your accounts in MMC. You will be able to see the number of opens and clicks each email has, bulk send individual emails, and automatically generate email activities on your accounts.",
    description: "Settings Email Preferences disconnected email sub title",
  },
  disconnectedEmailTitle: {
    id: "settings.emailPreferences.disconnectedEmail.title",
    defaultMessage: "Send and track emails in MMC",
    description: "Settings Email Preferences disconnected email title",
  },
  erroredDescription: {
    id: "settings.emailPreferences.error.description",
    defaultMessage:
      "Your email client requires you to re-authorize this sync. Please either re-authorize the connection or disconnect.",
    description: "Settings Email Preferences error description",
  },
  erroredDisconnect: {
    id: "settings.emailPreferences.errored.disconnect",
    defaultMessage: "Disconnect",
    description: "Settings Email Preferences errored disconnect button",
  },
  erroredReAuthorize: {
    id: "settings.emailPreferences.errored.reAuthorize",
    defaultMessage: "Re-authorize",
    description: "Settings Email Preferences errored re-authorize button",
  },
  erroredTitle: {
    id: "settings.emailPreferences.errored.title",
    defaultMessage: "Sync paused",
    description: "Settings Email Preferences errored title",
  },
});

export default messages;
